import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AulaRoutingModule } from './aula-routing.module';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { ListagemAulaComponent } from './listagem-aula/listagem-aula.component';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { PreAulaComponent } from './pre-aula/pre-aula.component';
import { SalaDeAulaComponent } from './sala-de-aula/sala-de-aula.component';
import { AvaliacaoAulaComponent } from './avaliacao-aula/avaliacao-aula.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [ListagemAulaComponent, PreAulaComponent, SalaDeAulaComponent, AvaliacaoAulaComponent],
  imports: [CommonModule, AulaRoutingModule, NgbDropdownModule, PipesModule, FormsModule, ReactiveFormsModule],
})
export class AulaModule {}
